import styled from 'styled-components/macro'

export const InvalidPayoutCommsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.v4.margins.content.medium} 0;
`
